export const sobActualsModalTranslation = {
  /**
   * Submit SOB Actuals
   * Отправить SOB Actuals
   */
  title: 'jbp-h2-review-sob-actuals-modal-title',

  /**
   * Show overall
   * Показать overall
   */
  showOverall: 'jbp-h2-review-sob-actuals-modal-show-overall',

  /**
   * Show SOB details
   * Показать SOB details
   */
  showSobDetails: 'jbp-h2-review-sob-actuals-modal-show-sob-details',

  /**
   * Cancel
   * Отмена
   */
  cancel: 'jbp-cancel',

  /**
   * Save
   * Сохранить
   */
  save: 'jbp-save',

  /**
   * Some SOB actuals fields are still empty or equal to 0. The plan cannot be reviewed until all required values are filled in.
   * Некоторые поля SOB actuals всё ещё пустые или равны 0. План нельзя проревьюить, пока все обязательные значения не заполнены.
   */
  incompleteWarning: 'jbp-h2-review-sob-actuals-modal-incomplete-warning',

  /**
   * Incomplete SOB Actuals
   * Незаполненные SOB Actuals
   */
  incompleteWarningTitle: 'jbp-h2-review-sob-actuals-modal-incomplete-warning-title',

  /**
   * Return to filling
   * Вернуться к заполнению
   */
  returnToFilling: 'jbp-h2-review-sob-actuals-modal-return-to-filling',

  /**
   * Save as is
   * Сохранить как есть
   */
  saveAsIs: 'jbp-h2-review-sob-actuals-modal-save-as-is',

  /**
   * Some settings for this section are unavailable. SOB actuals fields are shown as editable without required highlighting.
   * Некоторые настройки этой секции недоступны. Поля SOB actuals показаны редактируемыми без обязательной подсветки.
   */
  settingsUnavailableWarning: 'jbp-h2-review-sob-actuals-modal-settings-unavailable-warning',

  /**
   * Subcategory values have been changed. You can recalculate the Overall values if needed. Please note: recalculation may affect previous reports!
   * Значения саб категорий были изменены. При необходимости вы можете перерасчитать значения Overall. Обратите внимание: перерасчет может повлиять на прошлые отчеты!
   */
  recalcNotice: 'jbp-h2-review-sob-actuals-modal-recalc-notice',

  /**
   * Overall values have been recalculated. You can undo the recalculation to restore the previous Overall values.
   * Значения Overall были перерасчитаны. Вы можете отменить перерасчет, чтобы вернуть прежние значения Overall.
   */
  recalcCancelNotice: 'jbp-h2-review-sob-actuals-modal-recalc-cancel-notice',

  /**
   * Recalculate Overall
   * Перерасчитать Overall
   */
  recalculate: 'jbp-h2-review-sob-actuals-modal-recalculate',

  /**
   * Undo recalculation
   * Отменить перерасчет
   */
  cancelRecalculate: 'jbp-h2-review-sob-actuals-modal-cancel-recalculate',

  /**
   * Reset changes
   * Сбросить изменения
   */
  resetChanges: 'jbp-h2-review-sob-actuals-modal-reset-changes',
}
